import React, { Component } from 'react';
import CargomaticModal from 'components/v2/modal';
import { findIndex, isEmpty, sortBy } from 'lodash';
import { uuid } from 'uuidv4';
import PhoneContact from 'components/v2/phone-contact';
import { Card, CardHeader, CardContent } from '@cargomatic/ui';
import DotsHorizontalButton from 'components/v2/buttons/DotsHorizontalButton';
import Badge from 'components/v2/Badge';
import EditButton from 'components/v2/buttons/EditButton';
import AddButton from 'components/v2/buttons/AddButton';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import { getClassName } from 'utils/ui/classes';
import { showToast } from 'stores/ToastStore';
import validator from 'email-validator';
import { useTranslation, withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import { getPhoneFormatterObject } from 'utils/formatters/Phone';
const AccountContactView = (props) => {
    const { contact } = props;
    const phoneNumber = getPhoneFormatterObject(contact.phone);
    const { t } = useTranslation();
    return (React.createElement("tr", null,
        React.createElement("td", { className: "" },
            React.createElement("div", { className: "w-20 truncate" },
                React.createElement("span", null, contact.name))),
        React.createElement("td", { className: "", style: {} },
            React.createElement("div", { className: "w-32" },
                phoneNumber && React.createElement("span", null, phoneNumber.formatInternational()),
                contact.phoneExtension && (React.createElement("span", { className: "pl-2" },
                    "X",
                    contact.phoneExtension)))),
        React.createElement("td", { className: "" },
            React.createElement("div", { className: "w-32 truncate" },
                React.createElement("span", null, contact.email))),
        React.createElement("td", { className: "", style: {} },
            React.createElement("div", { className: "w-20" }, contact.contactType && (React.createElement(Badge, { size: "large", color: getContactTypeColor(contact.contactType) }, t(sluggify(contact.contactType)))))),
        React.createElement("td", { className: "text-right" },
            React.createElement("div", { className: "actions" },
                React.createElement(DotsHorizontalButton, { onClick: () => props.onEditContacts() })))));
};
const getContactTypeColor = (type) => {
    switch (type) {
        case 'Mobile':
            return 'blue';
        case 'Finance':
            return 'yellow';
        case 'Dispatch':
            return 'purple';
        case 'Escalation':
            return 'red';
        case 'Operations':
            return 'brand';
        default:
            return 'gray';
    }
};
const AccountContactsView = (props) => {
    let { contacts, t } = props;
    const hasContacts = contacts && contacts.length > 0;
    contacts = hasContacts ? sortBy(contacts, props.sortKey) : [];
    const NAME = t('NAME');
    const TYPE = t('TYPE');
    const PHONE = titleize(t('PHONE'));
    const EMAIL = titleize(t('EMAIL'));
    return (React.createElement(Card, null,
        React.createElement(CardHeader, null,
            React.createElement("header", { className: "flex items-center justify-between" },
                React.createElement("h3", { className: "my-0" }, titleize(t('CONTACT', { count: 2 }))),
                React.createElement("div", { className: "flex items-center space-x-4" },
                    hasContacts && (React.createElement("div", { className: "items-center actions space-x-2" },
                        React.createElement("label", { className: "block text-sm form-label" }, t('SORT_BY')),
                        React.createElement("div", { className: "w-24" },
                            React.createElement("select", { className: "form-select", onChange: (e) => props.onSortSelect(e.target.value) },
                                React.createElement("option", { value: "name" }, NAME),
                                React.createElement("option", { value: "contactType" }, TYPE),
                                React.createElement("option", { value: "phone" }, PHONE),
                                React.createElement("option", { value: "email" }, EMAIL))))),
                    React.createElement(EditButton, { onClick: () => props.onEditContactsClick() })))),
        React.createElement(CardContent, null,
            !hasContacts && (React.createElement("div", null,
                React.createElement("span", null, t('NO_CONTACT_AVAILABLE')))),
            hasContacts && (React.createElement("div", null,
                React.createElement("div", { className: "overflow-x-auto card--no-top-padding card--no-x-padding divide-solid divide-y-2 divide-gray-200" },
                    React.createElement("table", { className: "default-table" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, NAME),
                                React.createElement("th", { style: {} }, PHONE),
                                React.createElement("th", { style: {} }, EMAIL),
                                React.createElement("th", { style: {} }, TYPE),
                                React.createElement("th", null, "\u00A0"))),
                        React.createElement("tbody", null, contacts.map((c) => (React.createElement(AccountContactView, { key: c._id, contact: c, onEditContacts: () => props.onEditContactsClick() })))))),
                React.createElement("div", { className: "mt-2 text-sm actions text-grey-900 " },
                    hasContacts ? contacts.length : 0,
                    " ",
                    t('TOTAL')))))));
};
const HeaderRow = (props) => {
    const { t } = props;
    return (React.createElement("tr", null,
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "" }, t('NAME', { count: 1 }))),
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "w-32" }, titleize(t('PHONE')))),
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "" }, titleize(t('EXTENSION')))),
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "" }, titleize(t('EMAIL')))),
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "" }, titleize(t('TYPE')))),
        React.createElement("th", { className: "" },
            React.createElement("span", { className: "" },
                React.createElement(AddButton, { size: "small", onClick: () => props.onAdd() })))));
};
const ContactsEditView = (props) => {
    const { contacts } = props;
    return (React.createElement("div", { className: "overflow-x-auto modal--no-padding" },
        React.createElement("table", { className: "default-table" },
            React.createElement("thead", { className: "" },
                React.createElement(HeaderRow, { t: props.t, onAdd: props.onAdd, clone: true })),
            React.createElement("tbody", { className: "" }, contacts.map((c, i) => {
                return (React.createElement(PhoneContact, { key: i, contact: c, handlePhoneChange: (key, value) => {
                        props.handleContactChange(c, { [key]: `${value}` });
                    }, onRemove: () => props.onRemove(c) }));
            })))));
};
class Contacts extends Component {
    constructor(props) {
        super(props);
        this.onEditContactsHide = () => {
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { showEditContactsModal: false });
            });
        };
        this.onContactsSortSelect = (contactSortKey) => this.setState({ contactSortKey });
        this.onEditContactsClick = () => {
            const { contacts } = this.state;
            if (contacts.length === 0) {
                contacts.push(this.getNewContact());
            }
            this.setState({
                showEditContactsModal: true,
                contacts,
                contactsEditableCopy: contacts,
            });
        };
        this.getNewContact = () => {
            return {
                _id: uuid(),
                name: '',
                phone: '',
                email: '',
                phoneExtension: '',
                contactType: '',
            };
        };
        this.onAddContact = () => {
            const newContact = this.getNewContact();
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { contactsEditableCopy: [...prevState.contactsEditableCopy, newContact] });
            });
        };
        this.onRemoveContact = (contact) => {
            this.setState((prevState) => {
                const index = prevState.contactsEditableCopy.findIndex((c) => c._id === contact._id);
                return Object.assign(Object.assign({}, prevState), { contactsEditableCopy: [
                        ...prevState.contactsEditableCopy.slice(0, index),
                        ...prevState.contactsEditableCopy.slice(index + 1),
                    ] });
            });
        };
        this.isNotEmptyContact = (c) => {
            return (!isEmpty(c.name) &&
                !isEmpty(c.phone) &&
                !isEmpty(c.email) &&
                !isEmpty(c.contactType));
        };
        this.onContactsSave = async () => {
            let valid = true;
            let { contactsEditableCopy } = this.state;
            const { t } = this.props;
            contactsEditableCopy = contactsEditableCopy.map((c) => {
                const result = this.validateContact(c);
                if (result.valid) {
                    c.isContactValid = true;
                    c.isContactTypeValid = true;
                    c.isPhoneValid = true;
                    c.isEmailValid = true;
                    return c;
                }
                valid = false;
                return result.contact;
            });
            if (!valid) {
                this.setState({ contactsEditableCopy });
            }
            else {
                try {
                    await UserWebAPIUtils.updateContacts(this.props.userId, contactsEditableCopy);
                    showToast(t('CONTACT_UPDATED'), t('CONTACT_UPDATED'), 'success');
                    this.setState((prevState) => {
                        const contacts = prevState.contactsEditableCopy.filter((c) => this.isNotEmptyContact(c));
                        return Object.assign(Object.assign({}, prevState), { contacts, contactsEditableCopy: contactsEditableCopy });
                    });
                    this.onEditContactsHide();
                }
                catch (e) {
                    showToast(t('CONTACT_UPDATE_FAILED'), e.message, 'error');
                }
            }
        };
        this.handleContactChange = (c, change) => {
            this.setState((prevState) => {
                const contact = Object.assign(Object.assign({}, c), change);
                const contactsEditableCopy = [...prevState.contactsEditableCopy];
                const index = findIndex(contactsEditableCopy, { _id: contact._id });
                contactsEditableCopy[index] = contact;
                return { contactsEditableCopy };
            });
        };
        const contacts = props.contacts && props.contacts.length > 0 ? props.contacts : [];
        this.state = {
            contacts,
            contactsEditableCopy: [...contacts],
            contactSortKey: 'name',
            showEditContactsModal: false,
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const { contacts } = this.state;
        if (contacts.length === 0 && newProps.contacts) {
            this.setState({
                contacts: newProps.contacts,
                contactsEditableCopy: [...newProps.contacts],
            });
        }
    }
    validateContact(contact) {
        let valid = true;
        // Providing Default Values
        contact.isNameValid = true;
        contact.isEmailValid = true;
        contact.isPhoneValid = true;
        contact.isContactValid = true;
        contact.isContactTypeValid = true;
        if (isEmpty(contact.name) || contact.name.length < 3) {
            contact.isNameValid = false;
            contact.isContactValid = false;
            valid = false;
        }
        if (isEmpty(contact.contactType)) {
            contact.isContactTypeValid = false;
            contact.isContactValid = false;
            valid = false;
        }
        const phoneNumber = getPhoneFormatterObject(contact.phone);
        if (!phoneNumber || !phoneNumber.isValid()) {
            contact.isPhoneValid = false;
            contact.isContactValid = false;
            valid = false;
        }
        if (!contact.email || !validator.validate(contact.email)) {
            contact.isEmailValid = false;
            contact.isContactValid = false;
            valid = false;
        }
        return { contact, valid };
    }
    render() {
        const { contacts, contactsEditableCopy, contactSortKey, showEditContactsModal, } = this.state;
        const { t } = this.props;
        const body = (React.createElement(ContactsEditView, { t: t, contacts: contactsEditableCopy, handleContactChange: this.handleContactChange, onAdd: this.onAddContact, onRemove: this.onRemoveContact }));
        const footer = (React.createElement("div", { className: "flex justify-end" },
            React.createElement("button", { onClick: () => this.onEditContactsHide(), className: "button button-secondary" }, t('CANCEL')),
            React.createElement("button", { onClick: () => this.onContactsSave(), className: "button button-green" }, titleize(t('SAVE')))));
        return (React.createElement("div", { className: getClassName(this.props.className) },
            React.createElement(AccountContactsView, { contacts: contacts, onSortSelect: this.onContactsSortSelect, sortKey: contactSortKey, onEditContactsClick: this.onEditContactsClick, t: t }),
            showEditContactsModal && (React.createElement(CargomaticModal, { backdrop: "static", dialogClassName: "modal-override-medium", showCloseButton: true, title: t('EDIT_CONTACTS'), show: showEditContactsModal, body: body, footer: footer, onHide: this.onEditContactsHide }))));
    }
}
export default withTranslation()(Contacts);
